import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card-body p-4 d-flex" }
const _hoisted_3 = { class: "form-check me-3" }
const _hoisted_4 = ["checked"]
const _hoisted_5 = { class: "py-2 px-4 bg-white d-none" }
const _hoisted_6 = { class: "table align-middle table-hover table-row-bordered gy-3" }
const _hoisted_7 = { class: "text-start text-gray-400 fw-bold text-uppercase gs-0" }
const _hoisted_8 = { class: "min-w-50px" }
const _hoisted_9 = { class: "text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZModal = _resolveComponent("VZModal")!

  return (_openBlock(), _createBlock(_component_VZModal, {
    title: `${_ctx.t('common.phoneNumbers')}`,
    id: _ctx.id,
    showDialog: _ctx.showDialog,
    onModalClose: _ctx.close,
    widthClass: 'width-550'
  }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, _toDisplayString(_ctx.t("common.close")), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneObj, (p, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "card mb-3 border"
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("input", {
                  type: "radio",
                  checked: p.defaultPhone === true || p.default_phone === true,
                  class: "form-check-input",
                  disabled: ""
                }, null, 8, _hoisted_4)
              ]),
              _createTextVNode(" " + _toDisplayString(p.phone_number || p.phoneNumber), 1)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_7, [
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.t("common.phoneNumber")), 1)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneObj, (p, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(p.phone_number || p.phoneNumber), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "id", "showDialog", "onModalClose"]))
}